<template>
	<div class="w1200 flex myinfo">
		<choice-menu></choice-menu>
		<div class="flex flex-direction align-stretch benben-flex-layout myinfo_1" v-loading="loading"  :element-loading-text="$t('拼命加载中')">
			<div class="myinfo_2">{{$t('联系客服')}}</div>
			<div class="flex flex-direction align-center benben-flex-layout">
				<img class="service_1" src="https://api.ezlunch.club/pc/image/39.png" alt="" srcset="">
				<div class="service_2">{{detail.tel}}</div>
				<div class="service_3">{{$t('客服工作时间')}}：{{detail.time}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ChoiceMenu from "../components/choiceMenu.vue"
	export default {
		components: {
			ChoiceMenu
		},
		data() {
			return {
				loading:true,
				detail:'',
			}
		},
		created() {
			this.post68e4adcb2856f()
		},

		methods: {
			gengxin(){
				this.loading = true
				this.post68e4adcb2856f()
			},
			post68e4adcb2856f(){
				this.$api.get(this.$apiUrls.post68e4adcb2856f).then((res) => {
					if(res.code == 1){
						this.detail = res.data
						this.loading = false
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			caozuo(type){
				let url = ''
				if(type == 1){
					url = 'bind'
				}
				this.$router.push({
					name: url,
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-loading-mask {
			opacity: 1 !important; 
			background-color: rgba(255, 255, 255, 1) !important;
		}
	}
	.myinfo{
		margin-top: 20px;
	}
	.myinfo_1{
		width: 980px;
		margin: 0 0 0 220px;
		padding:0 20px 100px;
		background: #fff;
		box-sizing: border-box;
	}
	.myinfo_2{
		padding: 20px 0;
		border-bottom: 1px solid #EEEEEE;
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.service_1{
		width: 200px;
		height: 200px;
		margin: 54px 0 0 0;
	}
	.service_2{
		font-weight: bold;
		font-size: 24px;
		color: #333333;
		margin: 22px 0 0 0;
	}
	.service_3{
		font-weight: 400;
		font-size: 20px;
		color: #666666;
		margin: 15px 0 0 0;
	}
</style>